import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { HiOutlineChevronRight } from "react-icons/hi2";
import { PiCertificate, PiNotebookBold, PiUsersThree } from "react-icons/pi";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { TbCategory } from "react-icons/tb";
import { MdOutlineAssignment } from "react-icons/md";
import { MdNotificationsNone } from "react-icons/md";
import { PiHandshake } from "react-icons/pi";
import { IoStatsChartOutline } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import { TbActivity } from "react-icons/tb";
import { GrPlan } from "react-icons/gr";
import { FaTasks } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { onChatActionUrl, onChatDataAction } from "../../Redux/Actions/AuthActions";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";

const SidePanelAdmin = (props) => {
    const dispatch = useDispatch()
    const chatToken = useSelector((state) => state.chatData);

    const [chatData, setChatData] = useState({
        "access_token": "",
        "user_name": ""
    })
    const handleChatRoomClick = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("access_token", chatData.access_token);
        formData.append("password", chatData.access_token);

        formData.append("username", chatData.user_name);

        dispatch(onChatActionUrl(formData));


    };
    const fetchChatData = () => {
        dispatch(onChatDataAction(setChatData))
    }
    useEffect(() => {
        if (!chatToken?.data?.user_name || !chatToken?.data?.access_token) {
            fetchChatData()
        }
    }, [])
    useEffect(() => {
        if (chatToken && chatToken?.data?.user_name && chatToken?.data?.access_token) {
            setChatData({
                user_name: chatToken.data?.user_name,
                access_token: chatToken.data?.access_token
            })
        }
    }, [chatToken])
    return (
        <>
            <div className="side-panel">
                <div className="logo position-relative"><Link to="/admin/dashboard"><img src={require("../../images/logo.svg").default} alt="" /></Link><span className="page-name">Admin</span></div>

                {/* <div className="fav-tab">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Nav variant="nav">
                            <Nav.Item>
                                <Nav.Link eventKey="first">Favorites</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="second">Recently</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content>
                            <Tab.Pane eventKey="first">
                                <ul className="tab-link">
                                    <li><Link>Overview</Link></li>
                                    <li><Link>Projects</Link></li>
                                </ul>
                            </Tab.Pane>
                            <Tab.Pane eventKey="second">
                                <ul className="tab-link">
                                    <li><Link>Overview</Link></li>
                                    <li><Link>Projects</Link></li>
                                </ul>
                            </Tab.Pane>

                        </Tab.Content>
                    </Tab.Container>
                </div> */}

                <div className="dash-link pt-2">
                    {/* <h6>Dashboard</h6> */}
                    <ul className="pt-0">
                        <li><NavLink to="/admin/dashboard"><HiOutlineChevronRight /> <img src={require("../../images/icon/agent.svg").default} alt="" /> Dashboard</NavLink></li>
                        <li><NavLink to="/admin-manger-user" className={props.type === "creator" ? "active" : ""}><HiOutlineChevronRight /> <PiUsersThree fontSize={20} /> Manage Users</NavLink></li>
                        <li><NavLink to="/admin/all-task" className={props.type === "url" ? "active" : ""}><HiOutlineChevronRight /> <PiNotebookBold fontSize={20} /> Manage Tasks</NavLink></li>
                        <li><NavLink to="/admin/nav/payout"><HiOutlineChevronRight /> <RiMoneyDollarCircleLine fontSize={20} /> Manage Payouts</NavLink></li>
                        <li><NavLink to="/admin/task-category"><HiOutlineChevronRight /> <TbCategory fontSize={20}
                        /> Task Category</NavLink></li>
                        <li><NavLink to="/admin/task-assign"><HiOutlineChevronRight /> <MdOutlineAssignment
                            fontSize={20}
                        /> Task Assign</NavLink></li>
                        <li><NavLink to="/admin/notification"><HiOutlineChevronRight /><MdNotificationsNone
                            fontSize={20}
                        /> Notification</NavLink></li>
                        <li><NavLink to="/admin/onboarding"><HiOutlineChevronRight /><PiHandshake
                            fontSize={20}
                        /> Onboarding</NavLink></li>
                        <li><NavLink to="/admin/static"><HiOutlineChevronRight /><IoStatsChartOutline
                            fontSize={20}
                        /> Statistics </NavLink></li>
                        <li><NavLink to="/admin/empolyee-list"><HiOutlineChevronRight />
                            <PiUsersThree fontSize={20} />
                            Empolyee </NavLink></li>
                        <li><NavLink to="/admin-setting"><HiOutlineChevronRight />
                            <IoSettingsOutline
                                fontSize={20} />
                            Setting </NavLink></li>
                        <li><NavLink to="/user-activity"><HiOutlineChevronRight />
                            <TbActivity
                                fontSize={20} />
                            User Activity </NavLink></li>
                        <li><NavLink to="/plans"><HiOutlineChevronRight />
                            <GrPlan className="me-1"
                                fontSize={18} />
                            Plans </NavLink></li>
                        <li><NavLink to="/task-type"><HiOutlineChevronRight />
                            <FaTasks
                                className="me-1"
                                fontSize={18} />
                            Task Type </NavLink></li>
                        {/* <li><NavLink to={`https://chat.dotasks.in/login?email=${chatData.user_name}&access_token=${chatData.access_token}&next=https://chat.dotasks.in/dotasksGD`} target="_blank"><HiOutlineChevronRight />
                            <IoChatbubbleEllipsesOutline className="me-1"
                                fontSize={18} />

                            Chat Room </NavLink></li> */}
                        <li><a href="#" onClick={handleChatRoomClick}>
                            <HiOutlineChevronRight />
                            <IoChatbubbleEllipsesOutline className="me-1" fontSize={18} />
                            Discussion Forum
                        </a></li>
                    </ul>
                </div>
            </div>

        </>
    )
}

export default SidePanelAdmin;